import auth from "../middleware/auth";
import isStaff from "@/router/middleware/isStaff.js";
import homeworkExists from "@/router/middleware/homework/homeworkExists.js";

export default [
    {
        path: "/homework",
        name: "homework.home",
        props: true,
        component: () => {
            return import(
                 "@/projects/homework/App.vue"
            );
        },
        meta: {
            middleware: [auth()],
            title: "j2homework",
            breadcrumb: { label: "j2homework" }
        },
        children: [
            {
                path: "",
                name: "homework.list",
                props: {subview:true},
                components: {
                    subview: () => {
                        return import(
                             "@/projects/homework/views/List.vue"
                        );
                    }
                },
                meta: {
                    title: "homework.list.title"
                }
            },
            {
                path: "create",
                name: "homework.create",
                props: {subview:true},
                components: {
                    subview: () => {
                        return import(
                             "@/projects/homework/views/CreateEdit.vue"
                        );
                    }
                },
                meta: {
                    title: "homework.create.title",
                    middleware: [isStaff],
                    breadcrumb() {
                        return { label: this.$t("homework.create.title") };
                    }
                }
            },
            {
                path: ":homeworkId",
                name: "homework.item",
                props: {subview:true},
                components: {
                    subview: () => {
                        return import(
                             "@/projects/homework/views/Item.vue"
                        );
                    }
                },
                meta: {
                    middleware: [homeworkExists],
                    breadcrumb() {
                        return { label: this.$t("homework.detail.title") };
                    }
                },
                children: [
                    {
                        path: "",
                        name: "homework.detail",
                        components: {
                            itemview: () => {
                                return import(
                                     "@/projects/homework/views/Detail.vue"
                                );
                            }
                        },
                        meta: {
                            title: "homework.detail.title",
                            breadcrumb: null
                        }
                    },
                    {
                        path: "edit",
                        name: "homework.edit",
                        props: true,
                        components: {
                            itemview: () => {
                                return import(
                                     "@/projects/homework/views/CreateEdit.vue"
                                );
                            }
                        },
                        meta: {
                            title: "homework.edit.title",
                            middleware: [isStaff],
                            breadcrumb() {
                                return {
                                    label: this.$t("homework.edit.title")
                                };
                            }
                        }
                    }
                ]
            }
        ]
    }
];
